import type { ModuleRoute } from '../types';
import { ContactlessPage } from './ContactlessPage';

/**
 * Public pages of this area (ADR 0022): `/k/:token` (the site's QR code) and `/s/:token` (a sign-in point). No sign-in and no
 * portal shell; both prefixes are LINK_KINDS in packages/shared/src/links.ts. Owned by Phase 3 task W21 (W23 wires it last).
 */
export const routes: ModuleRoute[] = [
  { path: '/k/:token', element: <ContactlessPage kind="k" />, public: true, area: 'any' },
  { path: '/s/:token', element: <ContactlessPage kind="s" />, public: true, area: 'any' },
];
